<template>
    <div>
        <v-container>
            <v-form v-model="valid">
                <v-col xs="12" lg="6">
                    <v-card>
                        <v-card-title>Warehouse details</v-card-title>
                        <v-card-text dense>
                            <v-text-field label="Warehouse ID" v-model="id" readonly dense outlined filled height="12"
                                          :hide-details="auto" class="mb-2"
                            ></v-text-field>
                            <v-text-field label="Name" v-model="name" dense outlined
                                          class="mb-2" :hide-details="auto"></v-text-field>
                            <v-text-field label="Name at peoplevox" v-model="whmName" dense outlined
                                          class="mb-2" :hide-details="auto"></v-text-field>
                            <v-textarea label="Address name" v-model="addressName" dense outlined
                                        class="mb-2" :hide-details="auto" rows="2"></v-textarea>
                            <v-text-field label="Street" v-model="street" dense outlined
                                          class="mb-2" :hide-details="auto"></v-text-field>
                            <v-text-field label="Number" v-model="number" dense outlined
                                          class="mb-2" :hide-details="auto"></v-text-field>
                            <v-text-field label="Town" v-model="town" dense outlined
                                          class="mb-2" :hide-details="auto"></v-text-field>
                            <v-text-field label="Postcode" v-model="postcode" dense outlined
                                          class="mb-2" :hide-details="auto"></v-text-field>
                            <v-text-field label="Country" v-model="country" dense outlined
                                          :hide-details="auto"></v-text-field>

                        </v-card-text>
                        <v-col xs="12" lg="2">
                            <v-btn color="primary" class="d-flex .justify-end" @click="saveWarehouseData">Save</v-btn>
                        </v-col>

                    </v-card>

                </v-col>
            </v-form>
        </v-container>
    </div>
</template>

<script>
  import {getCookie} from '@/helpers/getCookie.js'


  const axios = require('axios')
  export default {
    name: "WarehouseDetails",
    components: {},
    data() {
      return {
        valid: false,
        id: "",
        name: "",
        whmName: "",
        addressName: "",
        street: "",
        number: "",
        town: "",
        postcode: "",
        country: "",
      }
    },
    mounted() {
      this.getWarehouseData()
    },
    methods: {
      getWarehouseData() {
        let redirectFunction = this.redirectToLogin
        let warehouseId = this.$route.params.id
        axios.get("/api/warehouses/" + warehouseId + "/", {
          headers: {
            Authorization: "Token " + this.$store.getters.authToken
          }
        }).then(this.setWarehouseData).catch(function (error) {
          if (403 === error.response.status) {
            alert("Failed to obtain data")
            redirectFunction()
          }
        })
      },
      setWarehouseData(response) {
        this.id = response.data.id
        this.name = response.data.name
        this.whmName = response.data.whm_name
        this.addressName = response.data.address.company_name
        this.street = response.data.address.street
        this.number = response.data.address.number
        this.town = response.data.address.town
        this.postcode = response.data.address.postcode
        this.country = response.data.address.country
      },
      redirectToLogin() {
        this.$router.push({name: 'login'})
      },
      saveWarehouseData() {
        var warehouseData = {
          name: this.name,
          whm_name: this.whmName,
          address: {
            company_name: this.addressName,
            street: this.street,
            number: this.number,
            town: this.town,
            postcode: this.postcode,
            country: this.country
          }
        }
        let redirectFunction = this.redirectToLogin
        let warehouseId = this.$route.params.id
        var url = "/api/warehouses/" + warehouseId + "/"

        axios.put(url, warehouseData, {
          headers: {
            //Authorization: "Token " + this.$store.getters.authToken,
            "X-CSRFToken": getCookie("csrftoken")
          },
        }).then(this.getWarehouseData).catch(function (error) {
          if (403 === error.response.status) {
            alert("Failed to obtain data")
            redirectFunction()
          }
        })
      }

    }
  }
</script>

<style scoped>
    .compact-inputa {
        transform: scale(0.85);
        transform-origin: left;
    }
</style>